import React from 'react';
import { UserOutlined, RobotOutlined } from '@ant-design/icons';

/**
 * Renders a circular avatar: image, or a colored div with optional icon.
 */
export default function ChatMessageAvatar({ src, icon, bg = '#3b82f6', size = 32 }) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: size * 0.45,
        flexShrink: 0,
      }}
    >
      {icon}
    </div>
  );
}

export { UserOutlined, RobotOutlined };
